module.exports = __webpack_public_path__ + "a2528c563d07bb7e6fc29e06b650d527.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/nvidia_2023_chart.png
// module id = 1705
// module chunks = 0